import { ChangeEvent } from "react";
import { useIntl } from "react-intl";
import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { IReferralLeaderboard } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { leaderBoardColumnsCreator } from "./utils";

export const ReferralLeaderboard = () => {
  const { isLoading, take, skip, onChangePage, allRows, totalCount } =
    useFetchQuery<IPaginationResult<IReferralLeaderboard>>("/referral/leaderboard");

  const { formatMessage } = useIntl();

  // prettier-ignore
  const columns = leaderBoardColumnsCreator(formatMessage);

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "referral", "referral.leaderboard"]} />

      <PageHeader message="pages.referral.leaderboard.title" />

      <SearchWithFilters endAdornment={null} />

      <DataGrid
        pagination
        paginationMode="server"
        rowCount={totalCount}
        paginationModel={{ page: skip / take, pageSize: take }}
        onPaginationModelChange={({ page }) => onChangePage({} as ChangeEvent<unknown>, page)}
        pageSizeOptions={[5, 10, 25]}
        loading={isLoading}
        columns={columns}
        rows={allRows}
      />
    </Grid>
  );
};
